import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CardRenderer } from "@/components/card/CardRenderer";
import { api } from "@/lib/api";

const noop = () => {};

export const DemoPhone = ({ slug, scale = 0.78, className = "", testId }) => {
  const [card, setCard] = useState(null);
  useEffect(() => {
    api.get(`/public/cards/${slug}`).then((r) => !r.data.redirect && setCard(r.data)).catch(() => {});
  }, [slug]);
  const w = 375 * scale;
  const h = 760 * scale;
  return (
    <Link to={`/c/${slug}`} className={`block shrink-0 transition-transform duration-500 hover:-translate-y-2 ${className}`} style={{ width: w, height: h }} data-testid={testId}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: "top left" }}>
        <div className="phone-frame">
          <div className="phone-screen pointer-events-none" style={{ background: card?.style.colors.background || "#111" }}>
            {card && <CardRenderer card={card} onSave={noop} onShare={noop} />}
          </div>
        </div>
      </div>
    </Link>
  );
};
